import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { EmptyStateMessage } from '~/ui/core/empty-state-message/EmptyStateMessage';
import { IconArchiveJunk } from '~/ui/core/icons';
import { SkeletonBase } from '~/ui/core/skeleton/Skeleton';

import { profileTaskTranslationKeys } from '../../profile-task-translations';

export const TaskTileLoading: FunctionComponent = () => {
    const translate = useTranslate();

    return (
        <div aria-label={translate(profileTaskTranslationKeys.loading)} className="flex flex-col gap-4xl" role="status">
            <SkeletonBase className="h-8 w-4/5" />
            <SkeletonBase className="h-20 w-full" />
            <SkeletonBase className="h-24 w-full" />
        </div>
    );
};

export const TaskTileError: FunctionComponent<{ readonly message?: string }> = ({ message }) => {
    const translate = useTranslate();

    return (
        <div className="flex w-full flex-1 flex-col gap-3xl" data-testid="task-tile-error">
            <h2 className="m-0 text-h3 font-medium leading-tight text-text-primary tracking-tight">
                {translate(profileTaskTranslationKeys.errorTitle)}
            </h2>
            <div className="w-full flex-1 pt-4xl">
                {message === undefined ? (
                    <EmptyStateMessage icon={<IconArchiveJunk size={24} />} />
                ) : (
                    <EmptyStateMessage>{message}</EmptyStateMessage>
                )}
            </div>
        </div>
    );
};
